<template>
  <v-app>
    <v-container fluid >
      <template v-if="$insertAccess($route.path)">
        <v-form @submit.prevent="submit">
          <v-row>
            <v-col cols="12">
              <v-expansion-panels v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-title
                    color="blue-grey-lighten-4"
                    class="panel-header"
                    >
                    <span>{{ isEntryMode ? "Add Project Progress Template" : "Update Project Progress Template" }}</span>
                    </v-expansion-panel-title
                  >
                  <v-expansion-panel-text>
                    <v-row class="py-2 no-gutters align-center">
                      <v-col lg="3" md="4" cols="12">
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          class="px-2"
                          v-model="name.value.value"
                          :error-messages="name.value.errorMessage"
                          hide-details="auto"
                        >
                          <template #label>
                           Configuration Name
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col lg="3" md="4" cols="12">
                        <v-date-input
                          label="Progress Date"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="progress_date.value.value"
                          :error-messages="progress_date.errorMessage.value"
                          autocomplete="off"
                          hide-details="auto"
                        ></v-date-input>
                      </v-col>
                     
                      <!-- <v-col lg="3" md="4" cols="12">
                        <v-date-input
                          label="Effective From Date"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="from_date.value.value"
                          :error-messages="
                            from_date.errorMessage.value
                          "
                          autocomplete="off"
                          clearable
                        ></v-date-input>
                      </v-col> -->

                      <!-- <v-col lg="3" md="4" cols="12">
                        <v-date-input
                          label="Effective To Date"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="to_date.value.value"
                          :error-messages="to_date.errorMessage.value"
                          autocomplete="off"
                          clearable
                        ></v-date-input>
                      </v-col> -->
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <v-table
                          density="compact"
                          :loading="loading"
                          fixed-header
                          class="table-dotted-border-bottom"
                          style="min-height: 40vh"
                        >
                          <thead>

                            <tr >
                              <th style="width: 5%">SL</th>
                              <th style="min-width: 200px">Task Name</th>
                              <th style="min-width: 150px">Task Type</th>
                              <th style="min-width: 180px">Start Date</th>
                              <th style="min-width: 180px">End Date</th>
                              <th style="min-width: 130px">Weight (%)</th>
                              <th style="min-width: 130px">Priority</th>
                              <th style="min-width: 120px">Step</th>
                              <th style="min-width: 140px">Status</th>
                              <th style="min-width: 20px">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(detail, index) in lists" :key="index">
                              <td class="text-center">{{ index + 1 }}</td>
                              <td class="py-1">
                                <v-text-field
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  class=""
                                  v-model="detail.task_name"
                                  :error-messages="getDetailError(index, 'task_name')"
                                  hide-details="auto"
                                  autocomplete="off"
                                >
                                  <template #label>
                                    Task Name
                                    <span class="text-red-accent-4">*</span>
                                  </template>
                                </v-text-field>
                              </td>
                              <td class="py-1">
                                <v-select
                                  label="Task Type"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  class=""
                                  v-model="detail.task_type"
                                  :items="[{label: 'urgent', display_text: 'Urgent'}, { label: 'semi-urgent', display_text: 'Semi Urgent'}, { label: 'Normal', display_text: 'normal' }]"
                                  :error-messages="getDetailError(index, 'task_type')"
                                  item-title="display_text"
                                  item-value="label"
                                  hide-details="auto"
                                  autocomplete="off"
                                >
                                  <template #label>
                                    Task Type
                                    <span class="text-red-accent-4">*</span>
                                  </template>
                                </v-select>
                              </td>

                              <td class="py-1">
                                <v-date-input
                                  label="From Date"
                                  density="compact"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-calendar"
                                  bg-color="grey-lighten-4"
                                  v-model="detail.from_date"
                                  :error-messages="getDetailError(index, 'from_date')"
                                  hide-details="auto"
                                  autocomplete="off"
                                ></v-date-input>
                              </td>

                              <td class="py-1">
                                <v-date-input
                                  label="To Date"
                                  density="compact"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-calendar"
                                  bg-color="grey-lighten-4"
                                  v-model="detail.to_date"
                                  :error-messages="getDetailError(index, 'to_date')"
                                  hide-details="auto"
                                  autocomplete="off"
                                ></v-date-input>
                              </td>

                              <td class="py-1">
                                <v-text-field
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  type="number"
                                  class=""
                                  v-model="detail.weight_value"
                                  :error-messages="getDetailError(index, 'weight_value')"
                                  hide-details="auto"
                                  autocomplete="off"
                                >
                                  <template #label>
                                    Weight Percent (%)
                                    <span class="text-red-accent-4">*</span>
                                  </template>
                                </v-text-field>
                              </td>

                              <td class="py-1">
                                <v-text-field
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  type="text"
                                  class=""
                                  v-model="detail.priority"
                                  :error-messages="getDetailError(index, 'priority')"
                                  hide-details="auto"
                                  autocomplete="off"
                                >
                                  <template #label>
                                    Priority
                                    <span class="text-red-accent-4">*</span>
                                  </template>
                                </v-text-field>
                              </td>

                              <td class="py-1">
                                <v-text-field
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  type="number"
                                  class=""
                                  v-model="detail.step"
                                  :error-messages="getDetailError(index, 'step')"
                                  hide-details="auto"
                                  autocomplete="off"
                                >
                                  <template #label>
                                    Step
                                    <span class="text-red-accent-4">*</span>
                                  </template>
                                </v-text-field>
                              </td>

                              <td class="py-1">
                                <v-select
                                  label="Status"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  class=""
                                  v-model="detail.temp_status"
                                  :items="[{label: 'open', display_text: 'Open'}, { label: 'on-going', display_text: 'On Going'}, { label: 'Closed', display_text: 'closed' }]"
                                  :error-messages="getDetailError(index, 'status')"
                                  item-title="display_text"
                                  item-value="label"
                                  hide-details="auto"
                                  autocomplete="off"
                                >
                                  <template #label>
                                    Status
                                    <span class="text-red-accent-4">*</span>
                                  </template>
                                </v-select>
                              </td>

                              <td class="py-1">
                                <v-btn
                                  @click="removeDetailRow(index)"
                                  variant="tonal"
                                  color="primary"
                                  v-if="index !== lists.length - 1"
                                >
                                  <v-icon
                                    color="red"
                                    icon="mdi-minus"
                                    size="medium"
                                  ></v-icon>
                                </v-btn>

                                <v-btn
                                  @click="addDetailRow"
                                  variant="tonal"
                                  color="primary"
                                  v-else
                                >
                                  <v-icon
                                    color="info"
                                    icon="mdi-plus"
                                    size="medium"
                                  ></v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-row class="pt-2">
                        <v-col cols="8">
                          <v-textarea
                            label="Remarks"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="remarks.value.value"
                            :error-messages="remarks.errorMessage.value"
                            autocomplete="off"
                            rows="3"
                            clearable
                          ></v-textarea>
                        </v-col>
                        <v-col lg="2" md="2" cols="12">
                          <!-- <v-checkbox
                            label="Active"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            color="primary"
                            class="px-2"
                            value="1"
                            :true-value="1"
                            :false-value="0"
                          ></v-checkbox>-->
                          <input
                            v-model="progress_template_master_id.value.value"
                            type="hidden"
                          />
                        </v-col>
                        <v-col cols="2">
                          <v-layout class="justify-end">
                            <v-btn
                              class="bg-brand w-15 ms-2"
                              variant="flat"
                              type="submit"
                            >
                              {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                          </v-layout>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-form>
      </template>
    </v-container>
  </v-app>
</template>

<script>
import { useField, useForm } from "vee-validate";
import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";
import formattedDate from "@/plugins/dateFormatter";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    isEntryMode: true,
    data: {},
    remarks: "",
    status: "1",
  }),
  watch: {},
  created() {},
  computed: {},
  methods: {
    closeDialog() {
      this.dialog = false;
      this.data = {};
    },
    resetForm() {
      this.data = {};
    },
  },

  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({}),
    });

    const name = useField("name");
    const progress_date = useField("progress_date");

    const remarks = useField("remarks");
    const status = useField("status");
    const progress_template_master_id = useField("progress_template_master_id");

    const detailErrors = reactive({});
    const errorMessages = ref("");

    const lists = ref([
      {
        task_name: "",
        task_type: "",
        from_date: "",
        to_date: "",
        weight_value: "",
        priority: "",
        step: "",
        temp_status: ""
      },
    ]);

    const addDetailRow = () => {
      lists.value.push({
        task_name: "",
        task_type: "",
        from_date: "",
        to_date: "",
        weight_value: "",
        priority: "",
        step: "",
        temp_status: ""
      });
    };

    const removeDetailRow = (index) => {
      if (lists.value.length > 1) {
        lists.value.splice(index, 1);
        delete detailErrors[index];
        const newErrors = {};
        Object.keys(detailErrors).forEach((key) => {
          const idx = parseInt(key);
          if (idx > index) {
            newErrors[idx - 1] = detailErrors[key];
          } else if (idx < index) {
            newErrors[idx] = detailErrors[key];
          }
        });
        Object.keys(detailErrors).forEach((key) => delete detailErrors[key]);
        Object.assign(detailErrors, newErrors);
      }
    };

    const loading = ref("");
    const isEntryMode = ref(true);

    const store = useStore();
    const router = useRouter();
    const validateDetailField = (index, field, value) => {
      if (!detailErrors[index]) {
        detailErrors[index] = {};
      }

      detailErrors[index][field] = "";

      switch (field) {
        case "task_name":
          if (!value || String(value).trim().length < 1) {
            detailErrors[index][field] = "Task Name is required";
          }
          break;

        case "weight_value":
          if (
            value === null ||
            value === undefined ||
            String(value).trim().length < 1
          ) {
            detailErrors[index][field] = "Weight Percent is required";
          } else {
            const num = Number(value);
            if (Number.isNaN(num) || num <= 0 || num > 100) {
              detailErrors[index][field] =
                "Weight Percent must be a number between 0.01 and 100";
            }
          }
          break;
      }
    };

    const getDetailError = (index, field) => {
      return detailErrors[index] && detailErrors[index][field]
        ? [detailErrors[index][field]]
        : [];
    };

    const validateAllDetails = () => {
      let isValid = true;
      lists.value.forEach((detail, index) => {
        validateDetailField(index, "task_name", detail.task_name);
        validateDetailField(index, "weight_value", detail.weight_value);

        if (detailErrors[index]) {
          Object.values(detailErrors[index]).forEach((error) => {
            if (error) isValid = false;
          });
        }
      });

      return isValid;
    };
    const submit = handleSubmit((values) => {
      // values.status = status.value.value ? 1 : 0;
      values.progress_date = formattedDate(progress_date.value.value);
      values.status = 1;

      values.lists = lists.value.map((detail) => ({
        task_name: detail.task_name,
        task_type: detail.task_type,
        from_date: formattedDate(detail.from_date),
        to_date: formattedDate(detail.to_date),
        weight_value: detail.weight_value,
        priority: detail.priority,
        step: detail.step,
        temp_status: detail.temp_status,
      }));

      store
        .dispatch("saveUpdateProgressTemplate", values)
        .then((response) => {
          resetForm();
          loading.value = false;
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "progress-template-list" });
          }, 2000);
        })
        .catch((error) => {
          loading.value = false;
          // toast.error(error.response.data.message);
          const backendErrors = error.response?.data?.errors;
          if (backendErrors && typeof backendErrors === 'object') {
              Object.values(backendErrors)
                  .flat()
                  .forEach(msg => toast.error(msg));
          } else {
              const msg = error.response?.data?.message || 'Failed to save';
              toast.error(msg);
          }
          return false;   
        });
    });
    onMounted(() => {
      const id = router.currentRoute.value.query.id;
      if (id) {
        store.commit("SET_LOADING", { color: "primary" });
        store
          .dispatch("getProgressTemplateListById", id)
          .then((matrix) => {
            isEntryMode.value = false;
            progress_template_master_id.value.value = matrix.id;
            name.value.value = matrix.name;
            progress_date.value.value = matrix.progress_date;
            remarks.value.value = matrix.remarks;
            status.value.value = matrix.status;
            if (matrix.details.length > 0) {
              lists.value = [];
            }

            (matrix.details || []).forEach((item) => {
              lists.value.push({
                task_name: item.task_name,
                task_type: item.task_type,
                from_date: item.from_date,
                to_date: item.to_date,
                // weight_value: item.weight_value,
                weight_value: item.weight_value,
                priority: item.priority,
                step: item.step,
                temp_status: item.temp_status,
              });
            });
            store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            store.commit("UNSET_LOADING");
            console.error("Failed to fetch receive:", error);
          });
      }
    });
    return {
      submit,
      name,
      progress_date,
      // to_date,
      lists,
      addDetailRow,
      removeDetailRow,
      remarks,
      status,
      errorMessages,
      isEntryMode,
      resetForm,
      progress_template_master_id,
      loading,
      detailErrors,
      validateDetailField,
      getDetailError,
      validateAllDetails,
    };
  },
};
</script>
